import { Table } from '@octano/global-ui';
import { useHistory } from 'react-router-dom';
import { PathsLayouts } from '../../../../config/routes';
import { useTexts } from '../hooks/textsContext';
import useColumnActions from '../hooks/useColumnActions';
import useColumns from '../hooks/useColumns';
import { AcademicLevels } from '../interfaces/type';
import Leyenda from './Leyenda';
import { useGradingStructureFormLoader } from './Loaders/GradingStructureFormLoader';
import { useGradingStructureLoader } from './Loaders/GradingStructureLoader';
import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../../components/text';
import { useMemo } from 'react';

function GradingStructureTable() {
  const texts = useTexts();
  const { data, loading } = useGradingStructureLoader();
  const { data: options } = useGradingStructureFormLoader();
  const history = useHistory();

  const onClickEdit = (row: AcademicLevels, deliveryMode: string) => {
    history.push(
      `${PathsLayouts.configurations}/grading-structure/${row.id}?deliveryMode=${deliveryMode}`,
    );
  };

  const columnsActions = useColumnActions({
    onClickEdit,
  });
  const columns = useColumns(columnsActions);

  const gradesStructuresOptions = useMemo(() => {
    return (deliveryMode: string) => {
      return (
        data?.data?.map((item) => {
          const structureType = item.gradesStructures.find(
            (gs) => gs.deliveryMode === deliveryMode,
          );
          return {
            ...item,
            structureType: structureType?.structureType,
            updatedAt: structureType?.updatedAt ?? item.updatedAt,
            deliveryMode,
          };
        }) ?? []
      );
    };
  }, [data?.data]);

  return (
    <Row container className="mb-5">
      <Col xs={12}>
        <header className="mb-3">
          <div className="mt-3">
            <p className="fs-16 text-light">{texts.subtitle}</p>
          </div>
        </header>
      </Col>

      <Col xs={12}>
        <Row className="d-flex flex-row align-items-center mb-4">
          {!!options?.structureType?.length &&
            options?.structureType?.map((option) => (
              <Col xs={12} lg={4} key={option.id}>
                <Leyenda structureType={option} showDescription />
              </Col>
            ))}
        </Row>
      </Col>

      {!!options?.modalitiesTypes?.length &&
        options?.modalitiesTypes?.map((option) => (
          <Col xs={12} key={option.code} className="mb-5">
            <div className="mb-2">
              <SectionTitle text={`MODALIDAD ${option.name.toUpperCase()}`} />
            </div>
            <Table
              columns={columns}
              data={gradesStructuresOptions(option.code)}
              isLoadingResults={loading}
              loadingView={{
                title: 'Estructura de calificaciones',
                subtitle: 'Espere un momento',
              }}
            />
          </Col>
        ))}
    </Row>
  );
}

export default GradingStructureTable;
